<template>
    <b-container
        :fluid="fluid"
        class="rkm-container"
    >
        <template v-if="noCard">
            <slot />
        </template>

        <rkm-card
            v-else
            :no-body="noBody"
        >
            <slot />
        </rkm-card>
    </b-container>
</template>

<script>
// Components.
import {BContainer} from 'bootstrap-vue'

export default {
    components: {BContainer},
    props: {
        fluid: {type: Boolean, default: true},
        noBody: {type: Boolean},
        noCard: {type: Boolean},
    },
}
</script>

<style scoped>
.rkm-container {
    margin-bottom: 15px;
    margin-top: 15px;
}
</style>